// src/redux/slices/streamingSlice.js
import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  enabled: false,
};

const streamingSlice = createSlice({
  name: 'streaming',
  initialState,
  reducers: {
    toggleStreaming: (state) => {
      state.enabled = !state.enabled;
    },
    setStreaming: (state, action) => {
      state.enabled = action.payload;
    },
    resetStreaming: () => initialState,
  },
});

export const { toggleStreaming, setStreaming, resetStreaming } =
  streamingSlice.actions;
export default streamingSlice.reducer;
